import React from "react";
import ServiceSection, { ServiceSectionProps } from "./base";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator, timelineItemClasses, timelineOppositeContentClasses } from "@mui/lab";
import { Typography } from "@mui/material";
import {LooksOne, LooksTwo, Looks3, Looks4, Looks5, Looks6} from '@mui/icons-material';

const ServiceSectionDeliveryFlow = (props: ServiceSectionProps) => {
  return (
    <ServiceSection service={props.service} headline={props.headline || "作業フロー"}>
      <Timeline className="delivery-flow-timeline">
        {props.service.detail.delivery_flow_section.items.map((item, index: number) => (
          <TimelineItem key={index}>
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot>
                { item.index === "01" ? <LooksOne /> : "" }
                { item.index === "02" ? <LooksTwo /> : "" }
                { item.index === "03" ? <Looks3 /> : "" }
                { item.index === "04" ? <Looks4 /> : "" }
                { item.index === "05" ? <Looks5 /> : "" }
                { item.index === "06" ? <Looks6 /> : "" }
              </TimelineDot>
            </TimelineSeparator>
            <TimelineContent sx={{ paddingTop: "72px", paddingBottom: "0px", paddingLeft: "32px"}}>
              <Typography variant="h6" component="span" sx={{fontWeight: "900"}}>
                {item.title}
              </Typography>
              <Typography>{item.contents.join("")}</Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </ServiceSection>
  )
}

export default ServiceSectionDeliveryFlow